// Note: this must be JS because it's used in server.js
// import type Rollbar from 'rollbar';

const rollbar = {
  isRollbarEnabled: () => ['production', 'development'].includes(process.env.NEXT_PUBLIC_APP_ENV || ''),
  /**
   * @returns {import('rollbar').Configuration}
   */
  rollbarConfig: () => ({
    accessToken: `${process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN}`,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      client: {
        javascript: {
          source_map_enabled: true,
        },
      },
      environment: `${process.env.NEXT_PUBLIC_APP_ENV}`,
    },
    hostSafeList: ['quattr.com'],
    codeVersion: process.env.CODEBUILD_RESOLVED_SOURCE_VERSION,
  }),
};

module.exports = rollbar;
